import React, {Fragment, useEffect, useState} from 'react';
import {Alert, Breadcrumb, Button, Card, Col, Container, Form, Row} from "@deere/ux.uxframe-react";
import {ERROR_MESSAGE, NEW_REQUEST1} from '../../shared/Constants';
import {Link, useHistory} from 'react-router-dom';
import {Loading} from '../../shared/Loading';
import '../../index.css'
import {useAuthConfig} from '../../shared/utils';
import {getSessionInfo} from "../../shared/UserLogin";
import {useOktaAuth} from "@okta/okta-react";

export default function NewRequest() {
    let authAxios = useAuthConfig();
    const {authState} = useOktaAuth();
    const info = getSessionInfo();
    const [material, setMaterial] = useState("");
    const [quantity, setQuantity] = useState("");
    const [plant, setPlant] = useState("");
    const [formError, setFormError] = useState("");
    const [message, setMessage] = useState("");
    const [alertVisible, setAlertVisible] = useState(false);
    const [switchView, setSwitchView] = useState("EN");
    const [isLoading, setIsLoading] = useState(false);
    const [requestorData, setRequestorData] = useState([]);
    const history = useHistory();
    const [smuser, setSmUser] = useState("");
    const [isValid, setIsvalid] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);
    useEffect(() => {
        if (authState.accessToken !== null) {
            getRequestorDetails();
        }
    }, [authState])
    const getRequestorDetails = async () => {
        setSmUser(info.userId);
        setIsLoading(true);
        await authAxios.post('/PDCReturn/UserValidation', {userId: info.userId})
            .then(res => {
                let result = res.data;
                if (result !== '') {
                    setRequestorData(result);
                }
                if (result.length === 0) {
                    setIsvalid("YES");
                } else {
                    setIsvalid("YES");
                }
                setIsLoading(false);
            }).catch(err => {
                setMessage(ERROR_MESSAGE);
                setIsLoading(false);
                setAlertVisible(true)
                makeMessageHidden()
            })
    }
    const validateForm = () => {
        let error = false;
        if (material === '') {
            error = {
                materialid: 'material',
                message: '',
            };
            return error;
        }
        if (quantity === '') {
            error = {
                quantityid: 'quantity',
                message: '',
            };
            return error;
        }
        if (plant === '') {
            error = {
                plantid: 'plant',
                message: '',
            };
            return error;
        }
        return error;
    };
    const handleMaterial = (e) => {
        let material = e.target.value.toUpperCase();
        setMaterial(material);
    }
    const hideAlert = () => {
        setAlertVisible(false)
    }
    const makeMessageHidden = () => {
        const timeout = setTimeout(() => {
            setAlertVisible(false)
        }, 5000)
        return () => clearTimeout(timeout)
    }
    const inputHandler = (e) => {
        const {value, maxLength} = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };
    const handleSubmit = (e) => {
        setFormError(null);
        let error = validateForm();
        if (error) {
            setFormError(error);
            return;
        }
        e.preventDefault();
        setIsDisabled(true);
        setIsLoading(true);
        authAxios.get(`/PDCReturn/ValidationCheck/${material}/${plant}`).then(res => {
            setIsLoading(false);
            if (!res.data.materialCheck) {
                setIsDisabled(false);
                setMessage(`That material ${material} was not found in PDC.`)
                setAlertVisible(true);
                makeMessageHidden();
            } //else if (res.data.plantCheck === false) {
                //     setIsDisabled(false);
                //     setMessage(`Please note: ${material} is not a valid ${plant} material number.`)
                //     setAlertVisible(true);
                //     makeMessageHidden();
            // }
            else {
                history.push({
                    pathname: "/step2", state: {
                        plant: plant,
                        material: material,
                        quantity: quantity,
                        message: !res.data.plantCheck ? `Please note: ${material} is not a valid ${plant} material number.` : ''
                    }
                })
            }
        }).catch(err => {
            setMessage(ERROR_MESSAGE);
            setAlertVisible(true)
            setIsDisabled(false);
            makeMessageHidden()
        })
    }
    return (
        <Fragment>
            <title>PDC Parts Request Form (step 1)</title>
            {alertVisible ? <Alert id="snackbar" onClose={hideAlert} accessibilityLabel="Success:" variant="warning"
                                   aria-atomic="true">
                <p className="uxf-alert-description">
                    {message}
                </p>
            </Alert> : null}
            {isLoading ? (
                <Loading/>
            ) : null}
            {isValid === "NO" ?
                <Card style={{margin: '2%'}}>
                    <Card.Body>
                        <Container fluid="xl">
                            <Row>
                                <Col xs={24}>
                                    <Form.Group>
                                        <Form.Label>Your userid <font color="990000">{smuser}</font> was not found in
                                            Outlook.</Form.Label><br/>
                                        <Form.Label>This is a requirement to use this website.</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Container>
                    </Card.Body>
                </Card> : null}
            {isValid === "YES" ?
                <Card style={{margin: '2%'}}>
                    <Card.Body>
                        <Container fluid="xl">
                            <Row>
                                <Col xs={24}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Breadcrumb links={[{
                                            title: "Home",
                                            to: "/"
                                        }, {
                                            title: "Step1"
                                        }]} label="breadcrumbs"
                                                    breadcrumbItemProps={{linkAs: Link}}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className='firstline' style={{marginLeft: '2%'}}>
                                            {NEW_REQUEST1}
                                        </Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Container>
                        <Form>
                            <Container fluid="xl">
                                <Row>
                                    <Col xs={12} md={7} style={{marginLeft: '2%', marginRight: '2%'}}>
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="uxf-label">
                                                Switch View:
                                            </Form.Label>
                                            <Form.Control as="select" className="custom-select"
                                                          onClick={(e) => setSwitchView(e.target.value)}>
                                                <option value="EN">US PAG</option>
                                                <option value="PT">Brazil</option>
                                                <option value="CN">China</option>
                                                <option value="CF">C&F</option>
                                                <option value="FR">France</option>
                                                <option value="GR">Germany</option>
                                                <option value="HI">India</option>
                                                <option value="PS">JDPS</option>
                                                <option value="MX">Mexico</option>
                                                <option value="NL">Netherlands</option>
                                                <option value="RU">Russia</option>
                                                <option value="SP">Spain</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={7} style={{marginLeft: '1.5%', marginRight: '2%'}}>
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="uxf-label">
                                                Plant:
                                            </Form.Label>
                                            <Form.Control as="select" className="custom-select"
                                                          onChange={(e) => setPlant(e.target.value)} required
                                                          value={plant}>
                                                <option value=""></option>
                                                {switchView === 'CF' ?
                                                    <>
                                                        <option value="DW01">DW01 - Davenport</option>
                                                        <option value="TX01">TX01 - Dubuque</option>
                                                    </>
                                                    : <>
                                                        <option value="AX01">AX01 - Seeding-Moline</option>
                                                        <option value="AX02">AX02 - Seeding-Valley City</option>
                                                        <option value="EX01">EX01 - Ottumwa</option>
                                                        <option value="GX01">GX01 - Greeneville</option>
                                                        <option value="GX03">GX03 - Greeneville Distribution Center
                                                        </option>
                                                        <option value="H101">H101 - Cylinder</option>
                                                        <option value="HX01">HX01 - Harvester</option>
                                                        <option value="JL01">JL01 - Paton</option>
                                                        <option value="LV01">LV01 - Augusta</option>
                                                        <option value="MX01">MX01 - Horicon</option>
                                                        <option value="MX32">MX32 - Horicon CCDC - (Janesville WH)
                                                        </option>
                                                        <option value="NX01">NX01 - Des Moines - NX01</option>
                                                        <option value="RX01">RX01 - Waterloo</option>
                                                        <option value="TC01">TC01 - Turf Care</option>
                                                        <option value="TC04">TC04 - Turf Care - (FGI)</option>
                                                        <option value="TC37">TC37 - Davenport TC - (ADC)</option>
                                                        <option value="T801">T801 - Thibodaux</option>
                                                        <option value="YK01">YK01 - Precision Upgrades</option>
                                                    </>
                                                }
                                            </Form.Control>
                                            <Form.Label>{formError && formError.plantid === 'plant' ? <Form.Label
                                                style={{color: "red"}}>{formError.message}</Form.Label> : null}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={7} style={{marginLeft: '2%', marginRight: '2%'}}>
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="uxf-label">
                                                Material:
                                            </Form.Label>
                                            <Form.Control type="text" maxLength="12" id="material" name="material"
                                                          required value={material} onChange={handleMaterial}/>
                                            <Form.Label>{formError && formError.materialid === 'material' ? <Form.Label
                                                style={{color: "red"}}>{formError.message}</Form.Label> : null}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={7} style={{marginLeft: '1.5%', marginRight: '2%'}}>
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="uxf-label">
                                                Quantity:
                                            </Form.Label>
                                            <Form.Control type="number" maxLength="10"
                                                          onKeyPress={inputHandler} id="quantity" name="quantity"
                                                          required value={quantity}
                                                          onChange={(e) => setQuantity(e.target.value)}/>
                                            {formError && formError.quantityid === 'quantity' ? <Form.Label
                                                style={{color: "red"}}>{formError.message}</Form.Label> : null}
                                        </Form.Group><br/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} style={{marginLeft: '0.5%'}}>
                                        <Form.Group as={Row} className="mb-3">
                                            <Col xs={3}>
                                                <Button variant="primary" type="submit" onClick={handleSubmit}
                                                        disabled={isDisabled}>
                                                    <font style={{"fontWeight": "bold"}}>Continue</font>
                                                </Button>
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Container>
                        </Form>
                    </Card.Body>
                </Card>
                : null}
        </Fragment>
    )
}